<template>
  <div :class="$style.container">
    <div :class="$style.list">
       <router-link
        :to="{ name: 'app-blogs-bookmarks' }"
      >
        <SidebarListItem :isActive="$route.name === 'app-blogs-bookmarks'">
          <template slot="icon">
            <BaseIcon :name="['far', 'bookmark']" />
          </template>
          {{ $t('blogBookmarks') }}
        </SidebarListItem>
      </router-link>
      <template v-if="!isFetched && !entitiesList.length">
        <SidebarContentLoader />
        <SidebarContentLoader />
        <SidebarContentLoader />
      </template>
      <template v-for="entity in entitiesList">
        <template v-if="entity.constructor.entity === 'blogs'">
          <BlogListItem :key="entity.uuid" :activeBlogId="activeBlogId" :blog="entity" />
        </template>
        <router-link
          v-if="entity.constructor.baseEntity === 'socialProfiles'"
          :key="entity.nickname"
          :to="{ name: 'social', params: { profileNickname: entity.nickname } }"
        >
          <SocialListItem
            :socialProfile="entity"
          />
        </router-link>
      </template>
      <infinite-loading
        @infinite="infiniteHandler"
        :class="$style.infiniteLoading"
      >
        <Spinner slot="spinner" />
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>
    <v-popover
      placement="top-end"
      offset="10"
      :class="$style.popover"
    >
      <div slot="popover" v-close-popover>
        <li
          :class="$style.menuItem"
          v-tooltip="$t('chat.mainMenu.createBlog')"
          @click="newBlog"
        >
          <img src="~@/assets/img/blog-menu-drop-icon.png" alt="blog-menu-drop-icon">
        </li>
        <li
          :class="$style.menuItem"
          v-tooltip="$t('chat.mainMenu.createProfile')"
          @click="newProfile"
        >
          <img src="~@/assets/img/social-menu-drop-icon.png" alt="social-menu-drop-icon">
        </li>
      </div>
      <Fab :class="['tooltip-target', $style.createButton]">
        <BaseIcon name="plus-circle" />
      </Fab>
    </v-popover>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SidebarListItem from '@/components/SidebarListItem'
import BlogListItem from './BlogListItem'
import SidebarContentLoader from '@/components/SidebarContentLoader'
import InfiniteLoading from 'vue-infinite-loading'
import Spinner from '@/components/Spinner'
import Fab from '@/components/Fab'
// import MenuBase from '@/components/MenuBase'
import SocialListItem from '@/views/Messenger/social/SocialListItem'

const OFFSET = 20

export default {
  name: 'blog-sidebar',
  components: {
    SidebarListItem,
    BlogListItem,
    SidebarContentLoader,
    InfiniteLoading,
    Spinner,
    Fab,
    SocialListItem
  },
  metaInfo () {
    return {
      title: this.$t('tabBlogs')
    }
  },
  props: {
    blogId: String
  },
  data () {
    return {
      isFetched: false,
      page: 0
    }
  },
  created () {
    this.fetchMyProfiles({ limit: 20, offset: 0 })
  },
  computed: {
    ...mapGetters({
      blogList: 'entities/blogs/myBlogs',
      profileList: 'entities/socialProfiles/myProfiles',
      blogById: 'entities/blogs/getBlog', // 'entities/blogs/find',
      isPremium: 'auth/isPremium'
    }),
    activeBlogId () {
      return this.blogId // this.$route.query.id
    },
    activeBlog () {
      return this.blogById(this.activeBlogId)
    },
    entitiesList () {
      return this.blogList
        .concat(this.profileList)
        .sort((a, b) => {
          let aKey = 'lastPostPublication'
          let bKey = 'lastPostPublication'
          if (a.constructor.baseEntity === 'socialProfiles') {
            aKey = 'updatedAt'
          }
          if (b.constructor.baseEntity === 'socialProfiles') {
            bKey = 'updatedAt'
          }
          return +new Date(b[bKey]) - +new Date(a[aKey])
        })
    }
  },
  watch: {
    activeBlogId: {
      immediate: true,
      handler (id) {
        this.$store.commit('entities/blogs/SET_ACTIVE', id)
      }
    }
  },
  methods: {
    ...mapActions({
      fetchMyBlogs: 'entities/blogs/fetchMyBlogs',
      fetchMyProfiles: 'entities/socialProfiles/fetchMyProfiles'
    }),
    async infiniteHandler ($state) {
      try {
        const blogs = await this.fetchMyBlogs({
          limit: OFFSET,
          offset: OFFSET * this.page
        })
        this.isFetched = true
        if (blogs.length < OFFSET) {
          $state.complete()
        } else {
          $state.loaded()
          this.page += 1
        }
      } catch (e) {}
    },
    newBlog () {
      if (this.isPremium) {
        this.$modal.show('create-blog')
      } else {
        this.$modal.show('premium-feature')
      }
    },
    newProfile () {
      if (this.isPremium) {
        this.$router.push({ name: 'social-create-profile' })
      } else {
        this.$modal.show('premium-feature')
      }
    }
  }
}
</script>

<style module lang="scss">
.container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 10px;
  position: relative;
  flex-grow: 1;
}
.list {
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: scroll;
}
// .link {
//   color: $text-darkest;
// }
.infiniteLoading {
  height: 50px;
  padding: 20px 0;
}
.createButton {
  font-size: 22px;
  width: 40px;
}
.popover {
  position: absolute;
  bottom: 15px;
  right: 15px;
}
.menuItem {
  cursor: pointer;
  img {
    width: 120px;
  }
}
</style>
